// removed by extract-text-webpack-plugin
module.exports = {"skill-list":"Skills__skill-list___2rWuc"};


//////////////////
// WEBPACK FOOTER
// ./src/components/resume/Skills.scss
// module id = 167
// module chunks = 0